import React from 'react';

import AddBillingRateButton from '@totem/components/billingRates/AddBillingRateButton';
import BillingRateReportContainer from '@totem/components/billingRates/BillingRateReportContainer';
import ReportTable from '@totem/components/billingRates/ReportTable';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

import './billingRateReport.css';

const BillingRateReportPage = () => {
  return (
    <ContentLayout>
      <BillingRateReportContainer onRecordTotalChanged={() => {}}>
        <IBCard
          isCovered
          title={'Billing Rates Report'}
          extra={<AddBillingRateButton />}
        >
          <ReportTable />
        </IBCard>
      </BillingRateReportContainer>
    </ContentLayout>
  );
};

export default BillingRateReportPage;
